import React from 'react'

import { NoImageContent, TopImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { List, SectionTitle, Text } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const Spending: React.FC<SectionProps> = ({ copy, topicKey }) => {
  const contentCopy = copy.spending_widget_overview

  const contentMap = {
    'spending-widget-overview': (
      <React.Fragment>
        <TopImageContent
          altImage={contentCopy.alt_image}
          content={
            <React.Fragment>
              <Text content={contentCopy.widget_instruction} />
              <List
                items={[
                  contentCopy.widget_overview_instruction_1,
                  contentCopy.widget_overview_instruction_2,
                  buildDynamicCopy(
                    contentCopy.widget_overview_instruction_3,
                    <b>{contentCopy.widget_overview_instruction_3_bold}</b>,
                  ) as React.ReactNode,
                ]}
                listType="ul"
              />
            </React.Fragment>
          }
          image={HELP_IMAGES.SPENDING_WIDGET}
          imageLargeBreakPoint={8}
          sx={{ pt: 48 }}
        />
        <NoImageContent
          content={
            <React.Fragment>
              <SectionTitle content={contentCopy.date_range_section_title} />
              <Text content={contentCopy.date_range_section} />
              <List
                items={[
                  buildDynamicCopy(
                    contentCopy.date_range_section_list_1,
                    <b>{contentCopy.date_range_section_list_1_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    contentCopy.date_range_section_list_2,
                    <b>{contentCopy.date_range_section_list_2_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    contentCopy.date_range_section_list_3,
                    <b>{contentCopy.date_range_section_list_3_bold}</b>,
                  ) as React.ReactNode,
                ]}
                listType="ul"
              />
            </React.Fragment>
          }
          hasDivider={false}
          sx={{ pt: 48 }}
        />
      </React.Fragment>
    ),
    'not-seeing-all-spending-categories': (
      <NoImageContent
        content={
          <List
            items={[
              buildDynamicCopy(
                contentCopy.spending_categories_list_1,
                <b>{contentCopy.spending_categories_list_1_bold_1}</b>,
                <b>{contentCopy.spending_categories_list_1_bold_2}</b>,
              ) as React.ReactNode,
              buildDynamicCopy(
                contentCopy.spending_categories_list_2,
                <b>{contentCopy.spending_categories_list_2_bold}</b>,
              ) as React.ReactNode,
              contentCopy.spending_categories_list_3,
            ]}
            listType="ul"
          />
        }
        hasDivider={false}
        sx={{ pt: 24 }}
      />
    ),
    'spending-categories-seem-inaccurate': (
      <NoImageContent
        content={
          <List
            items={[contentCopy.category_seem_off_list_1, contentCopy.category_seem_off_list_2]}
          />
        }
        hasDivider={false}
        sx={{ pt: 24 }}
      />
    ),
  }

  return contentMap[topicKey as keyof typeof contentMap]
}

export default Spending
